import { AuthService } from './../../services/auth.service';
import { HelpersService } from 'src/app/services/helpers.service';
import { Component, OnInit } from '@angular/core';
import { User } from 'src/app/models/user.model';

@Component({
  selector: 'app-detalhes',
  templateUrl: './detalhes.component.html',
  styleUrls: ['./detalhes.component.css']
})
export class DetalhesComponent implements OnInit {

  showSpinner = true;
  showNotas = false;
  escolherPerfil = true;

  constructor(private auth: AuthService,
              public helper: HelpersService) { }

  ngOnInit(): void {
    this.auth.authGuard().then(() => {
      this.auth.getUser.then((user: User) => {

        if (user.perfis.length > 0) {
          const perfilhackathon = user.perfis.find(perfil => perfil.hackathonId === this.helper.hackathonId);

          if (perfilhackathon.perfil > 0) {
            this.escolherPerfil = false;
          }

          if (perfilhackathon.perfil === 0) {
            this.escolherPerfil = false;
          }

        }

        this.showSpinner = false;
      });
    });
  }

  userPerfil(perfil: number) {
    this.helper.mostrarPerfil(perfil);
    this.auth.addPerfil(this.helper.hackathonId, perfil);
    this.helper.redirecionarAoSelecionarPerfil(perfil);
    this.escolherPerfil = false;
  }

}
